import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const title = 'My Contacts'

const ContactsPageHome = () => {
    const { updateAppHeaderContent } = React.useContext(AppHeaderContext)

    React.useEffect(() => {
        updateAppHeaderContent('Contacts')
    }, [updateAppHeaderContent])

    return (
        <div className="App">
            <header className="App-header">
                <Typography variant="h1">{title}</Typography>
            </header>
        </div>
    )
}

export default ContactsPageHome
